import { defineStore } from 'pinia'
import { watch } from 'vue'

import { useTransactionsQueryStore } from '@transactions/stores/transactionsQueryStore'
import { usePointsQueryStore } from '@points/stores/pointsQueryStore'
import { useFinanceQueryStore } from '@finance/stores/financeQueryStore'
import { useUserQueryStore } from '@youandco/stores/userQueryStore'

import { queryController } from '@composables/queryController'

export const useQueryStore = defineStore('useQueryStore', () => {
  const transactions = useTransactionsQueryStore()
  const points = usePointsQueryStore()
  const finance = useFinanceQueryStore()
  const user = useUserQueryStore()

  const { replaceQuery, cleanQueryObjFromEmpty } = queryController()

  watch([
    () => transactions.state,
    () => transactions.detailsState,
    () => points.pointsState,
    () => points.pointDetailsState,
    () => finance.financeState,
    () => user.userDetailsState
  ], () => {
    replaceQuery(cleanQueryObjFromEmpty({
      ...transactions.state,
      ...transactions.detailsState,
      ...points.pointsState,
      ...points.pointDetailsState,
      ...finance.financeState,
      ...user.userDetailsState
    }))
  }, { deep: true })

  return {}
})
